import { createContext, useState, useContext } from 'react';

const DataContext = createContext(null);

export const DataProvider = ({ children }) => {
  const [recipeFull, setRecipeFull] = useState(null);

  return (
    <DataContext.Provider value={{ recipeFull, setRecipeFull }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);
